export const PARANOIDI_TERMINAL_MESSAGES = [
  {
    id: "gig-starts",
    fi: "Keikka alkaa. Paperilappuja ei tarvita.",
    en: "The gig starts. No paper notes needed.",
  },
  {
    id: "audience-requests",
    fi: "Yleisö toivoo. Sinä päätät mitä soitetaan.",
    en: "The requests come in. You decide what gets played.",
  },
  {
    id: "setlist-ready",
    fi: "Settilista tallessa. Sanoitukset mukana. Valmiina lavalle.",
    en: "Setlist saved. Lyrics ready. Time to hit the stage.",
  },
  {
    id: "qr-ready",
    fi: "QR-koodi esiin ja toiveet jonoon.",
    en: "Show the QR code and let the requests roll in.",
  },
];